import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import authService from '../services/AuthService';

const ProtectedRoute = ({ children, requiredRole }) => {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      await authService.init();
      const user = authService.getCurrentUser();
      const role = authService.getUserRole();
      
      if (!user) {
        setIsAuthorized(false);
        return;
      }

      setUserRole(role);

      // Check if user has required role
      if (requiredRole) {
        setIsAuthorized(authService.hasPermission(requiredRole));
      } else {
        setIsAuthorized(true);
      }
    };

    checkAuth();

    // Subscribe to auth changes
    const unsubscribe = authService.onAuthChange((user) => {
      if (!user) {
        setIsAuthorized(false);
      } else {
        setUserRole(user.role);
        if (requiredRole) {
          setIsAuthorized(authService.hasPermission(requiredRole));
        } else {
          setIsAuthorized(true);
        }
      }
    });

    return unsubscribe;
  }, [requiredRole]);

  // Loading state
  if (isAuthorized === null) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#6D4F79'
      }}>
        Loading...
      </div>
    );
  }

  // Not authenticated
  if (!isAuthorized) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Wrong role - redirect to appropriate dashboard
  if (requiredRole && !authService.hasPermission(requiredRole)) {
    const dashboardRoute = authService.getDashboardRoute(userRole);
    return <Navigate to={dashboardRoute} replace />;
  }

  return children;
};

export default ProtectedRoute;